import React, {useState} from 'react';
import axios from 'axios';
import {Alert, AlertIcon, Box, Button, Flex, FormControl, FormLabel, Heading, Input, Text} from '@chakra-ui/react';

export default function ResetCodeLimit() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState<{ok: boolean; message: string} | null>(null);
  const reset = async (event: React.FormEvent) => {
    event.preventDefault();
    if (busy) return;
    setBusy(true); setResult(null);
    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/admin/registrations/reset-code-limit`,
        {email: email.trim().toLowerCase()}, {withCredentials: true, timeout: 25000});
      setResult({ok: true, message: response.data.message});
    } catch (error: any) {
      setResult({ok: false, message: error.response?.data?.message || error.response?.data?.error?.message || 'Could not clear the limit. Please retry.'});
    } finally {setBusy(false);}
  };
  return <Box as="form" onSubmit={reset} borderWidth="1px" borderRadius="xl" p={4} mb={5}>
    <Heading size="sm" mb={2}>Reset code-request limit</Heading>
    <Text fontSize="sm" color="admin.muted" mb={3}>Help someone blocked by too many signup or login code requests. Enter their email, even if their account was deleted.</Text>
    <Flex gap={3} align="end" wrap="wrap">
      <FormControl isRequired flex="1" minW="220px"><FormLabel htmlFor="reset-code-email">Email address</FormLabel>
        <Input id="reset-code-email" type="email" required maxLength={254} value={email} isDisabled={busy}
          placeholder="name@example.com" onChange={e => {setEmail(e.target.value); setResult(null);}} />
      </FormControl>
      <Button type="submit" colorScheme="purple" isLoading={busy} loadingText="Clearing limit" isDisabled={!email.trim()}>Clear limit</Button>
    </Flex>
    <Text fontSize="xs" color="admin.muted" mt={2}>Clears the account request allowance and resend cooldown. Ask them to request a new code afterwards; this does not send one.</Text>
    {result && <Alert status={result.ok ? 'success' : 'error'} mt={3}><AlertIcon />{result.message}</Alert>}
  </Box>;
}
